// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    isMockEnabled: true, // You have to switch this, when your real back-end is done
    authTokenKey: "authce9d77b308c149d5992a80073637e4d5",
    Use_Analytics: false,

    //test setup
    // BASE_URL_PROFILE: "http://192.168.128.154:82/hec-profile-rest/rest/",
    // BASE_URL_COMMON: "http://192.168.128.154:82/hec-common-rest/rest/",
    // BASE_URL_PUCA: "http://192.168.128.154:82/hec-das-rest/rest/",
    // BASE_URL_HRD_PUCA: "http://192.168.128.154:82/hec-hrd-rest/rest/",
    // BASE_URL_RPT: "http://192.168.128.154:82/hec-rpt-rest/rest/",

    // 10.87.192.240

    //test setup UAT
    // BASE_URL_PROFILE: "http://10.72.1.73:81/hec-profile-rest/rest/",
    // BASE_URL_COMMON: "http://10.72.1.73:81/hec-common-rest/rest/",
    // BASE_URL_PUCA: "http://10.72.1.73:81/hec-das-rest/rest/",
    // BASE_URL_HRD_PUCA: "http://10.72.1.73:81/hec-hrd-rest/rest/",
    // BASE_URL_HRD: "http://10.72.1.73:81/hec-hrd-rest/rest/",
    // BASE_URL_RPT: "http://10.72.1.73:81/hec-rpt-rest/rest/",

    // test setup
    // BASE_URL_LGSP: "http://10.72.1.71:8089/sc-v1/",
    // BASE_URL_AUTHENTICATE: "http://10.72.1.71:8089/sc-v1/",  


    BASE_URL_LGSP: "https://scholarship.hec.gov.pk/sc-v1/",

    BASE_URL_AUTHENTICATE: "https://scholarship.hec.gov.pk/sc-v1/",

    // BASE_URL_ACCEPT_IPFP: "http://10.110.0.149:8089/sc-v1/",
    BASE_URL_ACCEPT_IPFP: "https://scholarship.hec.gov.pk/sc-v1/",


    // //Prod
    BASE_URL_PROFILE: "https://scholarship.hec.gov.pk/hec-profile-rest/rest/",
    BASE_URL_COMMON: "https://scholarship.hec.gov.pk/hec-common-rest/rest/",
    BASE_URL_PUCA: "https://scholarship.hec.gov.pk/hec-das-rest/rest/",
    BASE_URL_HRD_PUCA: "https://scholarship.hec.gov.pk/hec-hrd-rest/rest/",
    BASE_URL_RPT: "https://scholarship.hec.gov.pk/hec-rpt-rest/rest/",
    BASE_URL_HRD: "https://scholarship.hec.gov.pk/hec-hrd-rest/rest/",

    JWT: "jwt",

    //http://10.87.204.240/

    version: 9.0,
    firebase: {
        apiKey: "AIzaSyDlfzULpcc-YpSuZp4sDct7y7lJGpe0j8Y",
        authDomain: "hec-project-9307e.firebaseapp.com",
        databaseURL: "https://hec-project-9307e.firebaseio.com",
        projectId: "hec-project-9307e",
        storageBucket: "hec-project-9307e.appspot.com",
        messagingSenderId: "983835680141",
        appId: "1:983835680141:web:5d2e4ddbd335b1395871c4",
        measurementId: "G-F3YCKCN2TT",
    },

    puca_batch: 38,
};

